module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.11cbd36a.woff2";